<template>
  <div class="content">
    <base-block class="mb-0" rounded title="Edit Question">
      <div class="row">
        <div class="col-md-6 form-group">
          Parent Topic
          <b-form-select v-model="parentTopic" @change="getTopics()" disabled>
            <option
              v-for="(parentTopic, index) in parentTopics"
              :key="index"
              :value="parentTopic.id"
            >
              {{ parentTopic.name }}
            </option>
          </b-form-select>
          <div v-if="parentTopicEmpty" style="color: red">
            Parent topic is required
          </div>
        </div>

        <div class="col-md-6 form-group">
          Topic
          <b-form-select v-model="topic" @change="getSubtopics()" disabled>
            <option
              v-for="(topic, index) in topics"
              :key="index"
              :value="topic.id"
            >
              {{ topic.name }}
            </option>
          </b-form-select>
          <div v-if="topicEmpty" style="color: red">Topic is required</div>
        </div>

        <div class="col-md-6 form-group">
          Sub Topic
          <b-form-select
            v-model="subtopic"
            @change="subtopicEmpty = false"
            disabled
          >
            <option
              v-for="(subtopic, index) in subtopics"
              :key="index"
              :value="subtopic.id"
            >
              {{ subtopic.name }}
            </option>
          </b-form-select>
          <div v-if="subtopicEmpty" style="color: red">
            Subtopic is required
          </div>
        </div>

        <div class="col-md-6 form-group">
          Question Type
          <b-form-select
            class="form-control"
            v-model="questionType"
            @change="questionTypeEmpty = false"
            disabled
          >
            <option
              v-for="(questionTypeOption, index) in questionTypeOptions"
              :key="index"
              :value="questionTypeOption.value"
            >
              {{ questionTypeOption.text }}
            </option>
          </b-form-select>
          <div v-if="questionTypeEmpty" style="color: red">
            Question type is required
          </div>
        </div>

        <div class="col-md-12">
          Question
          <vue-editor
            v-model="question"
            required
            @focus="questionEmpty = false"
            :config="config"
          />
          <!-- <ckeditor
            :config="config"
            v-model="question"
            @focus="questionEmpty = false"
            required
          ></ckeditor> -->
          <div v-if="questionEmpty" style="color: red">
            Question is required
          </div>
          <br />
        </div>

        <div class="col-md-6" v-for="(option, index) in options" :key="index">
          <div class="form-group" v-if="questionType == 'objective'">
            Option {{ index + 1 }}
            <input
              class="form-control"
              placeholder="Enter an option"
              v-model="options[index].option"
              @focus="option1Empty = false"
            />
            <div v-if="option1Empty" style="color: red">Option is required</div>
          </div>
        </div>
        <div class="w-100" v-if="questionType == 'objective'"></div>
        <div class="col-md-6 form-group">
          Question Image
          <b-form-file
            type="file"
            class="form-control"
            @change="questionImage = $event.target.files[0]"
          ></b-form-file>
        </div>
        <div class="col-md-6 form-group" v-if="questionType != 'objective'">
          Correct Answer
          <input
            class="form-control"
            v-model="correctAnswer"
            @focus="correctAnswerEmpty = false"
            required
          />
          <div v-if="correctAnswerEmpty" style="color: red">
            Correct answer is required
          </div>
        </div>
        <div
          class="col-md-6 form-group"
          v-if="questionType != '' && questionType == 'coding'"
        >
          Minimum Lines
          <input class="form-control" v-model="minimum_lines" required />
        </div>

        <div class="col-md-6 form-group" v-if="questionType == 'objective'">
          Correct Option
          <b-form-select
            class="form-control"
            v-model="correctAnswer"
            @focus="correctAnswerEmpty = false"
            required
          >
            <option
              v-for="(option, index) in options"
              :key="index"
              :value="option.option"
            >
              {{ index + 1 }}
            </option>
          </b-form-select>
          <div v-if="correctAnswerEmpty" style="color: red">
            Correct option is required
          </div>
        </div>

        <div
          class="row m-0"
          style="width: 100%"
          v-for="(soln, index) in moreSolution"
          :key="index"
        >
          <div class="col-md-6 form-group">
            Solution Type
            <b-form-select
              class="form-control"
              v-model="moreSolution[index].solutionType"
              @change="solutionTypeEmpty = false"
              required
            >
              <option value="video">video</option>
              <option value="description">description</option>
            </b-form-select>
            <div
              v-if="solutionTypeEmpty && moreSolution[index].solutionType == ''"
              style="color: red"
            >
              Solution type is required
            </div>
          </div>

          <div
            class="col-md-5 form-group"
            v-if="
              moreSolution[index].solutionType == 'video' && correctAnswer != ''
            "
          >
            Video Name
            <input
              class="form-control"
              v-model="moreSolution[index].videoName"
              @focus="solutionNameEmpty = false"
              required
            />
            <div
              v-if="solutionNameEmpty && moreSolution[index].videoName == ''"
              style="color: red"
            >
              Video Name is required
            </div>
          </div>
          <div
            class="col-md-5 form-group"
            v-if="
              moreSolution[index].solutionType == 'description' &&
                correctAnswer != ''
            "
          >
            Solution Image
            <b-form-file
              type="file"
              class="form-control"
              @change="
                moreSolution[index].solutionImage = $event.target.files[0]
              "
            />
          </div>

          <div
            class="col-md-1 form-group"
            v-if="moreSolution[index].solutionType != '' && correctAnswer != ''"
          >
            <b-button
              variant="danger"
              class="mt-4"
              @click="removeSolution(index, moreSolution[index].solutionId)"
              ><i class="fas fa-trash"></i
            ></b-button>
          </div>

          <div
            class="col-md-12 form-group"
            v-if="
              moreSolution[index].solutionType == 'video' &&
                moreSolution[index].solutionType != '' &&
                correctAnswer != ''
            "
          >
            Solution URL
            <input
              class="form-control"
              placeholder="Enter Youtube URL"
              v-model="moreSolution[index].solutionURL"
              @focus="solutionURLEmpty = false"
              required
            />
            <div
              v-if="solutionURLEmpty && moreSolution[index].solutionURL == ''"
              style="color: red"
            >
              Solution URL is required
            </div>
          </div>

          <div
            class="col-md-12 form-group"
            v-if="
              moreSolution[index].solutionType == 'description' &&
                moreSolution[index].solutionType != '' &&
                correctAnswer != ''
            "
            w
          >
            Solution
            <vue-editor
              :config="config"
              v-model="moreSolution[index].solutionDescription"
              @focus="solutionDescriptionEmpty = false"
            />
            <!-- <ckeditor
              :config="config"
              v-model="moreSolution[index].solutionDescription"
              @focus="solutionDescriptionEmpty = false"
            ></ckeditor> -->
            <div
              v-if="
                solutionDescriptionEmpty &&
                  moreSolution[index].solutionDescription == ''
              "
              style="color: red"
            >
              Solution description is required
            </div>
          </div>
        </div>
        <div class="text-right col-md-12 form-group" v-if="correctAnswer != ''">
          <b-button variant="success" @click="appendMoreSolution()"
            >Add Solution</b-button
          >
        </div>
      </div>
      <div class="text-center form-group" v-if="saveEnable()">
        <b-button variant="success" type="submit" @click="addQuestion()"
          >Save Changes</b-button
        >
      </div>
      <!-- Loader -->
      <b-overlay
        :show="loader"
        no-wrap
        blur="2px"
        opacity="0.60"
        class="position-fixed"
      >
        <template #overlay>
          <i class="fa fa-3x fa-cog fa-spin text-primary"></i>
        </template>
      </b-overlay>
    </base-block>
    <br />
  </div>
</template>

<script>
import axios from "axios";

export default {
  mounted() {
    this.loadData();
    this.getParentTopics();
  },
  methods: {
    async loadData() {
      await axios
        .get(
          `${this.$store.getters.baseUrl}/question/edit/${this.$route.params.id}`,
          {
            headers: { Authorization: `Bearer ${this.$store.getters.token}` },
          }
        )
        .then(async (response) => {
          console.log(response);
          if (response.data.status == "success") {
            this.id = response.data.question.id;
            this.parentTopic = response.data.question.belongtopics[0].id;
            this.getTopics();
            this.topic = response.data.question.belongtopics[1].id;
            this.getSubtopics();
            this.subtopic = response.data.question.belongtopics[2].id;
            this.questionType = response.data.question.question_type;
            this.question = response.data.question.question;
            this.minimum_lines = response.data.question.minimum_lines;
            if (this.questionType == "objective") {
              for (var x = 0; x < response.data.question.options.length; x++) {
                this.options.push({
                  id: response.data.question.options[x].id,
                  option: response.data.question.options[x].option,
                });
              }
            }
            console.log(this.options);
            this.questionImage = response.data.question.image;
            this.correctAnswer = response.data.question.answer;

            if (response.data.question.solutions.length > 0) {
              for (
                var i = 0;
                i < response.data.question.solutions.length;
                i++
              ) {
                if (
                  response.data.question.solutions[i].type.toLowerCase() ===
                  "video".toLowerCase()
                ) {
                  this.moreSolution.push({
                    solutionType: "video",
                    solutionId: response.data.question.solutions[i].id,
                    solutionURL: response.data.question.solutions[i].video_url,
                    solutionDescription: "",
                    videoName: response.data.question.solutions[i].description,
                    solutionImage: "",
                  });
                } else {
                  this.moreSolution.push({
                    solutionType: "description",
                    solutionId: response.data.question.solutions[i].id,
                    solutionURL: "",
                    solutionDescription:
                      response.data.question.solutions[i].description,
                    videoName: "",
                    solutionImage: response.data.question.solutions[i].image,
                  });
                  console.log(response.data.question.solutions[i].image);
                }
              }
            } else this.moreSolution = [];
          } else {
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    async removeSolution(index, id) {
      if (id) {
        await axios
          .get(`${this.$store.getters.baseUrl}/solution/delete/${id}`, {
            headers: {
              Authorization: `Bearer ${this.$store.getters.token}`,
            },
          })
          .then((response) => {
            console.log(response);
            if (response.data.status == "success") {
              this.moreSolution.splice(index, 1);
            } else {
              this.$swal("Error", response.data.message, "warning");
            }
          })
          .catch((error) => {
            console.log(error);
            this.$swal("Error", error.response.data.message, "error");
          });
      } else {
        this.moreSolution.splice(index, 1);
      }
    },

    async addQuestion() {
      if (this.parentTopic == "") {
        this.parentTopicEmpty = true;
        return;
      }

      if (this.topic == "") {
        this.topicEmpty = true;
        return;
      }

      if (this.subtopic == "") {
        this.subtopicEmpty = true;
        return;
      }

      if (this.questionType == "") {
        this.questionTypeEmpty = true;
        return;
      }

      if (this.question == "") {
        this.questionEmpty = true;
        return;
      }

      if (this.correctAnswer == "") {
        this.correctAnswerEmpty = true;
        return;
      }

      if (this.questionType == "objective") {
        for (var q = 0; q < this.options.length; q++) {
          if (this.options[q].option == "") {
            this.option1Empty = true;
            return;
          }
        }
      }
      if (this.moreSolution.length > 0) {
        for (var x = 0; x < this.moreSolution.length; x++) {
          if (this.moreSolution[x].solutionType == "") {
            this.solutionTypeEmpty = true;
            return;
          }

          if (this.moreSolution[x].solutionType == "video") {
            if (this.moreSolution[x].solutionURL == "") {
              this.solutionURLEmpty = true;
              return;
            }

            if (this.moreSolution[x].videoName == "") {
              this.solutionNameEmpty = true;
              return;
            }
          } else {
            if (this.moreSolution[x].solutionDescription == "") {
              this.solutionDescriptionEmpty = true;
              return;
            }
          }
        }
      }
      this.loader = true;
      let solutions = [];
      for (var i = 0; i < this.moreSolution.length; i++) {
        if (this.moreSolution[i].solutionType == "video") {
          solutions.push({
            type: this.moreSolution[i].solutionType,
            solutionId: this.moreSolution[i].solutionId,
            video_url: this.moreSolution[i].solutionURL,
            video_name: this.moreSolution[i].videoName,
          });
        } else {
          solutions.push({
            type: this.moreSolution[i].solutionType,
            solutionId: this.moreSolution[i].solutionId,
            description: this.moreSolution[i].solutionDescription,
            image: this.moreSolution[i].solutionImage,
          });
        }
      }
      let topicIds = [this.parentTopic, this.topic, this.subtopic];
      const formdata = new FormData();
      formdata.append("question_id", this.id);
      formdata.append("topic_id", this.subtopic);
      formdata.append("question", this.question);
      formdata.append("minimum_lines", this.minimum_lines);
      formdata.append("question_type", this.questionType);
      formdata.append("image", this.questionImage);
      console.log(this.questionImage);
      formdata.append("answer", this.correctAnswer);
      formdata.append("topic_ids", topicIds);
      for (var j = 0; j < solutions.length; j++) {
        if (solutions[j].type == "video") {
          formdata.append(
            "solutions[" + j + "][id]",
            solutions[j].solutionId ? solutions[j].solutionId : ""
          );
          formdata.append("solutions[" + j + "][type]", "video");
          formdata.append(
            "solutions[" + j + "][video_url]",
            solutions[j].video_url
          );
          formdata.append(
            "solutions[" + j + "][video_name]",
            solutions[j].video_name
          );
        } else {
          formdata.append(
            "solutions[" + j + "][id]",
            solutions[j].solutionId ? solutions[j].solutionId : ""
          );
          formdata.append("solutions[" + j + "][type]", "description");
          formdata.append(
            "solutions[" + j + "][description]",
            solutions[j].description
          );
          formdata.append("solutions[" + j + "][image]", solutions[j].image);
        }
      }
      if (this.questionType == "objective") {
        for (var k = 0; k < this.options.length; k++) {
          formdata.append("options[" + k + "][id]", this.options[k].id);
          formdata.append("options[" + k + "][option]", this.options[k].option);
        }
      }
      await axios
        .post(
          `${this.$store.getters.baseUrl}/question/update/${this.id}`,
          formdata,
          {
            headers: {
              Authorization: `Bearer ${this.$store.getters.token}`,
            },
          }
        )
        .then((response) => {
          if (response.data.status == "success") {
            console.log(response);
            this.loader = false;
            this.$swal("Success", "Question updated successfully", "success");
            this.$router.push({ name: "Tables Questions" });
            (this.parentTopic = ""), (this.topic = "");
            this.subtopic = "";
            this.questionType = "";
            this.question = "";
            this.questionImage = "";
            this.correctAnswer = "";
            this.options = [];
            this.moreSolution = [];
            solutions = [];
          } else {
            this.loader = false;
            this.$swal("Error", response.data.message, "warning");
          }
        })
        .catch((error) => {
          console.log(error);
          this.loader = false;
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    async getSubtopics() {
      this.topicEmpty = false;
      this.subtopic = "";
      await axios
        .get(`${this.$store.getters.baseUrl}/topics/${this.topic}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          this.subtopics = response.data.topics;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    async getTopics() {
      this.parentTopicEmpty = false;
      this.topic = "";
      await axios
        .get(`${this.$store.getters.baseUrl}/topics/${this.parentTopic}`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          this.topics = response.data.topics;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    async getParentTopics() {
      await axios
        .get(`${this.$store.getters.baseUrl}/topics`, {
          headers: {
            Authorization: `Bearer ${this.$store.getters.token}`,
          },
        })
        .then((response) => {
          console.log(response);
          this.parentTopics = response.data.topics;
        })
        .catch((error) => {
          console.log(error);
          this.$swal("Error", error.response.data.message, "error");
        });
    },

    appendMoreSolution() {
      this.moreSolution.push({
        solutionType: "",
        solutionId: "",
        solutionURL: "",
        solutionDescription: "",
        videoName: "",
        solutionImage: "",
      });
    },

    saveEnable() {
      if (this.correctAnswer != "") {
        return true;
      } else return false;
    },
  },
  data() {
    return {
      config: {
        toolbar: [
          {
            name: "clipboard",
            groups: ["clipboard", "undo"],
            items: [
              "Cut",
              "Copy",
              "Paste",
              "PasteText",
              "PasteFromWord",
              "-",
              "Undo",
              "Redo",
            ],
          },
          {
            name: "editing",
            groups: ["find", "selection", "spellchecker"],
            items: ["Find", "Replace", "-", "SelectAll", "-", "Scayt"],
          },
          { name: "links", items: ["Link", "Unlink", "Anchor"] },
          {
            name: "insert",
            items: [
              "Image",
              "Flash",
              "Table",
              "HorizontalRule",
              "Smiley",
              "SpecialChar",
              "PageBreak",
              "Iframe",
            ],
          },
          { name: "tools", items: ["Maximize", "ShowBlocks"] },
          {
            name: "document",
            groups: ["mode", "document", "doctools"],
            items: ["Source"],
          },
          {
            name: "basicstyles",
            groups: ["basicstyles", "cleanup"],
            items: [
              "Bold",
              "Italic",
              "Underline",
              "Strike",
              "Subscript",
              "Superscript",
              "-",
              "CopyFormatting",
              "RemoveFormat",
            ],
          },
          "/",
          {
            name: "paragraph",
            groups: ["list", "indent", "blocks", "align", "bidi"],
            items: [
              "NumberedList",
              "BulletedList",
              "-",
              "Outdent",
              "Indent",
              "-",
              "Blockquote",
              "CreateDiv",
              "-",
              "JustifyLeft",
              "JustifyCenter",
              "JustifyRight",
              "JustifyBlock",
              "-",
              "BidiLtr",
              "BidiRtl",
              "Language",
            ],
          },

          { name: "styles", items: ["Styles", "Format", "Font", "FontSize"] },
          { name: "colors", items: ["TextColor", "BGColor"] },
          { name: "others", items: ["-"] },
          { name: "about", items: ["About"] },
          { name: "mathjax", items: ["Mathjax"] },
        ],
        extraPlugins: ["mathjax", "font", "justify"],
        mathJaxLib:
          "//cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.5/MathJax.js?config=TeX-AMS_HTML",
      },
      id: "",
      loader: false,
      solutionDescriptionEmpty: false,
      solutionNameEmpty: false,
      solutionURLEmpty: false,
      solutionTypeEmpty: false,
      option1Empty: false,
      correctAnswerEmpty: false,
      questionEmpty: false,
      questionTypeEmpty: false,
      subtopicEmpty: false,
      topicEmpty: false,
      parentTopicEmpty: false,
      options: [],
      requiredSolutionIndex: "",
      questionTypeOptions: [
        {
          text: "Fillups",
          value: "fill_in_blank",
        },
        {
          text: "MCQ",
          value: "objective",
        },
        {
          text: "Coding",
          value: "coding",
        },
      ],
      subtopic: "",
      subtopics: [],
      parentTopic: "",
      topic: "",
      topics: [],
      parentTopics: [],
      question: "",
      questionType: "",
      questionImage: "",
      correctAnswer: "",
      moreSolution: [],
      minimum_lines: "",
    };
  },
};
</script>
